import styled from 'styled-components';

export const Modals = styled.div`
.spinner-border {
   width: 6rem;
   height: 6rem;
   color: ${props => props.theme.colors.primary} !important;
}
`;